import styles from "./ElementTooltipName.module.scss";
import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";

function ElementTooltipName({ node }) {
  const _name = nodeUtils.getName(node);

  return <div className={styles["tooltip__name"]}>{_name}</div>;
}

export default ElementTooltipName;
